export default __webpack_public_path__ + "static/media/SHOP.3ebb141c.png";